export const BaseURL = "https://apistaging.scubers.com/api/v1/";
export const cities = `/lookups/cities`;
export const PresignedURL = `generate_presigned_url`;
export const languages = "/lookups/get_supported_languages?page_size=1000";
export const userType = localStorage.getItem('userType')